import * as React from 'react';
export default function SvgFaceSmile() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.627 13.01a.75.75 0 0 1 .86.604l.003.01a1.12 1.12 0 0 0 .211.396c.166.2.515.48 1.299.48.784 0 1.133-.28 1.299-.48a1.12 1.12 0 0 0 .21-.396l.003-.01a.75.75 0 0 1 1.478.26l-.74-.124.74.123v.004l-.002.005-.002.011a.986.986 0 0 1-.025.111 2.616 2.616 0 0 1-.51.976C13.992 15.53 13.216 16 12 16s-1.992-.47-2.451-1.02a2.616 2.616 0 0 1-.51-.976 1.797 1.797 0 0 1-.025-.111l-.002-.011-.001-.005v-.002c0-.001 0-.002.739-.125l-.74.124a.75.75 0 0 1 .617-.864ZM9 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM14 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Z",
    fill: "currentColor"
  }));
}